// cspell:ignore coordorigin coordsize roundrect arcsize strokecolor strokeweight fillcolor anchorlock atleast
const ALLOWED_PROTOCOLS = /^https?:\/\//i;

/**
 * 320px max-width video endlink card. One table per media item.
 *
 * Dual-branch layout for email-client compatibility:
 *  - `<!--[if gte mso 9]>` block renders Outlook-safe VML: a 292×164 canvas
 *    with the thumbnail painted via `v:fill type="frame"` on a rounded
 *    `v:roundrect`, plus an absolutely-positioned pill + triangle play
 *    glyph. Every shape carries the endlink href so the whole card is
 *    clickable in Outlook (no fragile `top:-128px` overlay anymore).
 *  - `<!--[if !mso]>` block renders the modern visual (CSS background
 *    thumbnail at 16:9, CSS-triangle play button inside a rounded pill).
 *
 * Placeholders: {{endlink}}, {{mediaId}}, {{title}}, {{thumbnailUrl}}.
 *
 * Intentional duplication — endlink and thumbnail each appear in both
 * branches, plus multiple anchor positions in the modern branch (overlay,
 * play button, title). This mirrors the eventual BFF-rendered shape so the
 * local builder swaps out cleanly once the server endpoint lands.
 */
const VIDEO_ENDLINK_TEMPLATE = `<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" bgcolor="#ffffff" style="width:100%;max-width:320px;margin:0 auto;border-collapse:collapse;border-spacing:0;border:0;mso-border-alt:none;mso-border-left-alt:none;mso-border-top-alt:none;mso-border-right-alt:none;mso-border-bottom-alt:none;mso-table-lspace:0pt;mso-table-rspace:0pt;background:#ffffff;"><tbody><tr><td data-media-ids="{{mediaId}}" data-thumbnail-media-id="{{mediaId}}" data-media-title="{{title}}" align="center" bgcolor="#ffffff" style="padding:0;background:#ffffff;font-size:0;line-height:0;border:0;mso-border-alt:none;mso-border-left-alt:none;mso-border-top-alt:none;mso-border-right-alt:none;mso-border-bottom-alt:none;"><!--[if gte mso 9]><table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" bgcolor="#ffffff" style="width:100%;max-width:320px;margin:0 auto;border-collapse:separate;border-spacing:0;background:#ffffff;border:1px solid #d7e2ee;border-radius:18px;mso-border-alt:1px solid #d7e2ee;mso-border-left-alt:1px solid #d7e2ee;mso-border-top-alt:1px solid #d7e2ee;mso-border-right-alt:1px solid #d7e2ee;mso-border-bottom-alt:1px solid #d7e2ee;mso-table-lspace:0pt;mso-table-rspace:0pt;"><tbody><tr><td bgcolor="#ffffff" style="padding:14px 14px 0 14px;background:#ffffff;font-size:0;line-height:0;border:0;mso-border-alt:none;mso-border-left-alt:none;mso-border-top-alt:none;mso-border-right-alt:none;mso-border-bottom-alt:none;"><table role="presentation" cellpadding="0" cellspacing="0" border="0" width="292" align="center" style="width:292px;border-collapse:collapse;border-spacing:0;border:0;mso-border-alt:none;mso-border-left-alt:none;mso-border-top-alt:none;mso-border-right-alt:none;mso-border-bottom-alt:none;mso-table-lspace:0pt;mso-table-rspace:0pt;"><tbody><tr><td width="292" height="164" style="width:292px;height:164px;background:#ffffff;font-size:0;line-height:0;mso-line-height-rule:exactly;border:0;mso-border-alt:none;mso-border-left-alt:none;mso-border-top-alt:none;mso-border-right-alt:none;mso-border-bottom-alt:none;"><v:group xmlns:v="urn:schemas-microsoft-com:vml" coordorigin="0,0" coordsize="292,164" filled="f" stroked="f" style="position:relative;width:292px;height:164px;"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="{{endlink}}" arcsize="8.6957%" stroked="f" fill="t" fillcolor="#e7edf3" style="position:absolute;left:0px;top:0px;width:292px;height:164px;v-text-anchor:middle;"><v:fill type="frame" src="{{thumbnailUrl}}" color="#e7edf3" aspect="atleast"/><w:anchorlock/></v:roundrect><v:roundrect xmlns:w="urn:schemas-microsoft-com:office:word" href="{{endlink}}" arcsize="100%" fillcolor="#000000" strokecolor="#ffffff" strokeweight="4px" style="position:absolute;left:86px;top:60px;width:120px;height:44px;v-text-anchor:middle;"><v:fill color="#000000" opacity="70%"/><w:anchorlock/></v:roundrect><v:shape xmlns:w="urn:schemas-microsoft-com:office:word" href="{{endlink}}" coordorigin="0 0" coordsize="14 18" path="m 0,0 l 14,9,0,18 x e" filled="t" fillcolor="#ffffff" stroked="f" style="position:absolute;left:141px;top:73px;width:14px;height:18px;"><v:fill color="#ffffff"/><w:anchorlock/></v:shape></v:group></td></tr></tbody></table></td></tr><tr><td class="buildvideohtml-card-title" bgcolor="#ffffff" style="padding:16px 16px 18px 16px;font-family:Arial,sans-serif;font-size:18px;line-height:24px;font-weight:bold;color:#10233b;background:#ffffff;border:0;mso-border-alt:none;mso-border-left-alt:none;mso-border-top-alt:none;mso-border-right-alt:none;mso-border-bottom-alt:none;"><a href="{{endlink}}" class="buildvideohtml-card-link" target="_blank" rel="noopener" style="text-decoration:none;color:#10233b;">{{title}}</a></td></tr></tbody></table><![endif]--><!--[if !mso]><!--><table style="max-width:320px;border-collapse:separate;margin:0 auto;width:100%;background:#ffffff;"><tbody><tr><td style="padding:0;border:1px solid #d7e2ee;border-radius:18px;overflow:hidden;background:#ffffff;"><div style="max-height:0;position:relative;opacity:0.999;overflow:visible;line-height:0;font-size:0;"><a href="{{endlink}}" class="buildvideohtml-card-link buildvideohtml-card-overlay" target="_blank" rel="noopener" style="display:block;text-decoration:none;color:transparent;background:transparent;"><span style="display:block;height:16px;font-size:0;line-height:0;">&nbsp;</span><span style="display:block;height:16px;font-size:0;line-height:0;">&nbsp;</span><span style="display:block;height:18px;font-size:0;line-height:0;">&nbsp;</span></a></div><table style="width:100%;border-collapse:separate;background:#ffffff;"><tbody><tr><td height="16" colspan="3" style="height:16px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td></tr><tr><td width="16" style="width:16px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td><td style="font-size:0;line-height:0;background:#ffffff;"><table style="width:100%;border-collapse:separate;"><tbody><tr><td style="font-size:0;line-height:0;background:url('{{thumbnailUrl}}') center center / cover no-repeat #0f223d;background-color:#0f223d;background-image:url('{{thumbnailUrl}}');background-position:center center;background-size:cover;background-repeat:no-repeat;border-radius:14px;overflow:hidden;"><div style="max-height:0;position:relative;opacity:0.999;overflow:visible;line-height:0;font-size:0;"><a href="{{endlink}}" class="buildvideohtml-card-link buildvideohtml-card-overlay-top" target="_blank" rel="noopener" style="display:block;height:0;padding-top:23.5475%;font-size:0;line-height:0;text-decoration:none;color:transparent;background:transparent;">&nbsp;</a><table role="presentation" cellpadding="0" cellspacing="0" border="0" align="center" style="width:120px;max-width:120px;margin:0 auto;border-collapse:separate;"><tbody><tr><td style="padding:0;font-size:0;line-height:0;"><a href="{{endlink}}" class="buildvideohtml-card-link" target="_blank" rel="noopener" style="display:block;padding:12.2222% 0;background:rgba(0, 0, 0, 0.7);border:4px solid #ffffff;border-radius:999px;text-align:center;text-decoration:none;color:transparent;font-size:0;line-height:0;mso-padding-alt:0;"><span style="display:inline-block;vertical-align:middle;padding:0px 0;line-height:0;font-size:0;"><span style="display:inline-block;width:1px;height:1px;background:transparent;border-radius:0;text-decoration:none;overflow:hidden;box-sizing:content-box;text-align:center;line-height:1px;font-size:1px;margin:0 0 0 4px;border-width:8px 0 8px 13px;border-style:solid;border-color:transparent transparent transparent #ffffff;vertical-align:middle;color:transparent;">&nbsp;</span></span></a></td></tr></tbody></table></div><a href="{{endlink}}" class="buildvideohtml-card-link" target="_blank" rel="noopener" style="display:block;height:0;padding-top:56.25%;font-size:0;line-height:0;text-decoration:none;color:transparent;background:transparent;">&nbsp;</a></td></tr></tbody></table></td><td width="16" style="width:16px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td></tr><tr><td height="16" colspan="3" style="height:16px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td></tr><tr><td width="16" style="width:16px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td><td class="buildvideohtml-card-title" style="font-family:Arial,sans-serif;font-size:18px;line-height:24px;font-weight:bold;color:#10233b;background:#ffffff;text-align:center;"><a href="{{endlink}}" class="buildvideohtml-card-link" target="_blank" rel="noopener" style="display:block;text-decoration:none;color:#10233b;">{{title}}</a></td><td width="16" style="width:16px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td></tr><tr><td height="18" colspan="3" style="height:18px;font-size:0;line-height:0;background:#ffffff;">&nbsp;</td></tr></tbody></table></td></tr></tbody></table><!--<![endif]--></td></tr></tbody></table>`;

/**
 * HTML-safe escaping for values landing in both attribute context
 * (`alt="..."`, `data-media-title="..."`) and text-node context
 * (`<a>...</a>`, `<p>...</p>`). Covers `&`, `<`, `>`, `"`, `'`.
 */
function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * URL sanitizer for the template's attribute + CSS-url() contexts. Rejects
 * any non-http(s) URL (returns empty string). Escapes `&`, `"`, `'` so the
 * URL is safe in `href="..."`, `src="..."`, and `background:url('...')`.
 */
function sanitizeUrl(url: string): string {
  if (!url || !ALLOWED_PROTOCOLS.test(url)) return "";
  return url
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export interface VideoEndlinkParams {
  endlinkUrl: string;
  mediaId: string;
  title: string;
  thumbnailUrl: string;
}

/**
 * Renders a single video endlink card by substituting values into
 * `VIDEO_ENDLINK_TEMPLATE`. Returns "" if `endlinkUrl` isn't a valid
 * http(s) URL — callers should treat empty output as a skip signal.
 */
export function buildVideoEndlinkHtml(params: VideoEndlinkParams): string {
  const safeEndlink = sanitizeUrl(params.endlinkUrl);
  if (!safeEndlink) return "";

  const safeThumbnail = sanitizeUrl(params.thumbnailUrl);
  const safeTitle = escapeHtml(params.title ?? "");
  const safeMediaId = escapeHtml(params.mediaId ?? "");

  return VIDEO_ENDLINK_TEMPLATE.replace(/{{endlink}}/g, safeEndlink)
    .replace(/{{thumbnailUrl}}/g, safeThumbnail)
    .replace(/{{title}}/g, safeTitle)
    .replace(/{{mediaId}}/g, safeMediaId);
}

/**
 * Applied at email send time. Each `span[data-media-widget]` is replaced
 * by one video endlink card per `<img>` child, all sharing the span's
 * endlink URL.
 *
 *  - Multi-endlink mode: N widgets × 1 img each → N cards
 *  - Single-endlink mode: 1 widget × N imgs → N cards sharing one endlink
 *
 * Per-image data (title, thumbnail, mediaId) comes from the `<img>`
 * attributes written by `buildMediaWidget`.
 *
 * Pure function: stateless, no side effects. Content without a media
 * widget span is returned unchanged.
 */
export function wrapMediaWidget(html: string): string {
  if (!html) return html;

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const widgets = Array.from(
    doc.querySelectorAll<HTMLElement>("span[data-media-widget]")
  );

  for (const widget of widgets) {
    const endlinkUrl = widget.getAttribute("data-media-widget");
    if (!endlinkUrl || !ALLOWED_PROTOCOLS.test(endlinkUrl)) continue;

    const images = Array.from(widget.querySelectorAll<HTMLImageElement>("img"));
    if (images.length === 0) continue;

    const cards = images
      .map(img =>
        buildVideoEndlinkHtml({
          endlinkUrl,
          mediaId: img.getAttribute("data-media-id") ?? "",
          title:
            img.getAttribute("data-media-title") ||
            img.getAttribute("alt") ||
            "",
          thumbnailUrl: img.getAttribute("src") ?? ""
        })
      )
      .filter(Boolean)
      .join("");

    if (!cards) continue;

    const temp = doc.createElement("div");
    temp.innerHTML = cards;

    const parent = widget.parentNode;
    if (!parent) continue;
    while (temp.firstChild) {
      parent.insertBefore(temp.firstChild, widget);
    }
    parent.removeChild(widget);
  }

  return doc.body.innerHTML;
}

/**
 * Editor-time preview card for a single `<img>`. Approximates the modern
 * (`!mso`) email branch: rounded container, thumbnail with centered play
 * circle, title below. No VML, no Outlook conditionals — purely for the
 * Kendo NodeView.
 *
 * `contenteditable=false` and `user-select:none` keep the card atomic in
 * ProseMirror so clicks create a NodeSelection instead of a caret inside it.
 */
export function buildMediaPreview(
  doc: Document,
  img: HTMLImageElement
): HTMLElement {
  const src = img.getAttribute("src") ?? "";
  const hasValidSrc = !!src && ALLOWED_PROTOCOLS.test(src);
  const title =
    img.getAttribute("data-media-title") || img.getAttribute("alt") || "";

  const card = doc.createElement("div");
  card.setAttribute("contenteditable", "false");
  card.style.cssText =
    "display:block;max-width:320px;margin:0 auto 8px auto;" +
    "border:1px solid #d7e2ee;border-radius:18px;overflow:hidden;" +
    "background:#ffffff;user-select:none;";

  const thumbPadding = doc.createElement("div");
  thumbPadding.style.cssText = "padding:16px 16px 0 16px;background:#ffffff;";

  // padding-top:56.25% → fixed 16:9 aspect ratio without intrinsic image sizing.
  const thumbWrapper = doc.createElement("div");
  thumbWrapper.style.cssText =
    "position:relative;width:100%;padding-top:56.25%;" +
    "border-radius:14px;overflow:hidden;background:#0f223d;" +
    (hasValidSrc
      ? `background-image:url('${src}');` +
        "background-position:center center;" +
        "background-size:cover;background-repeat:no-repeat;"
      : "");

  // White-bordered pill matching the email template's VML roundrect /
  // modern-branch pill (120×44, 4px white border, translucent dark fill).
  const playPill = doc.createElement("div");
  playPill.style.cssText =
    "position:absolute;top:50%;left:50%;" +
    "transform:translate(-50%,-50%);" +
    "width:120px;height:44px;border-radius:999px;" +
    "background:rgba(0,0,0,0.7);border:4px solid #ffffff;" +
    "display:flex;align-items:center;justify-content:center;" +
    "box-sizing:border-box;";

  // CSS-triangle play glyph — no hosted asset. Left-margin nudge mirrors
  // the optical-center offset in the email template.
  const playTriangle = doc.createElement("span");
  playTriangle.style.cssText =
    "display:block;width:0;height:0;margin-left:4px;" +
    "border-style:solid;border-width:8px 0 8px 13px;" +
    "border-color:transparent transparent transparent #ffffff;";
  playPill.appendChild(playTriangle);
  thumbWrapper.appendChild(playPill);
  thumbPadding.appendChild(thumbWrapper);

  const titleBar = doc.createElement("div");
  titleBar.style.cssText =
    "padding:16px 16px 18px 16px;font-family:Arial,sans-serif;" +
    "font-size:18px;line-height:24px;font-weight:bold;" +
    "color:#10233b;background:#ffffff;text-align:center;";
  titleBar.textContent = title;

  card.appendChild(thumbPadding);
  card.appendChild(titleBar);

  return card;
}
